import { useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import PosterCard from "./PosterCard";

export default function ContentRail({ title, items, locked }) {
  const ref = useRef(null);
  const scroll = (dir) => {
    if (!ref.current) return;
    ref.current.scrollBy({ left: dir * (ref.current.offsetWidth * 0.8), behavior: "smooth" });
  };

  if (!items || items.length === 0) return null;

  return (
    <section data-testid={`rail-${title.toLowerCase().replace(/\s+/g, "-")}`} className="relative">
      <div className="flex items-end justify-between mb-4">
        <h2 className="font-display text-xl md:text-2xl font-bold text-white tracking-tight">{title}</h2>
        <div className="hidden md:flex gap-2">
          <button
            data-testid={`rail-prev-${title.toLowerCase().replace(/\s+/g, "-")}`}
            onClick={() => scroll(-1)}
            className="w-9 h-9 rounded-full bg-white/5 hover:bg-white/10 border border-white/10 grid place-items-center transition"
            aria-label="Scroll left"
          >
            <ChevronLeft className="w-4 h-4 text-white" />
          </button>
          <button
            data-testid={`rail-next-${title.toLowerCase().replace(/\s+/g, "-")}`}
            onClick={() => scroll(1)}
            className="w-9 h-9 rounded-full bg-white/5 hover:bg-white/10 border border-white/10 grid place-items-center transition"
            aria-label="Scroll right"
          >
            <ChevronRight className="w-4 h-4 text-white" />
          </button>
        </div>
      </div>
      <div ref={ref} className="flex gap-4 overflow-x-auto scrollbar-hide pb-3 -mx-1 px-1">
        {items.map((item) => (
          <PosterCard key={item.id} item={item} locked={locked} />
        ))}
      </div>
    </section>
  );
}
